import React from 'react';
import { Backdrop, createStyles, Fade, makeStyles, Modal, Theme } from '@material-ui/core';
import { useCancelRoute } from 'hooks';
import { DeleteErrorCityModal } from './DeleteErrorCityModal';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    form: {
      backgroundColor: theme.palette.background.paper,
      border: '0px',
      borderRadius: '2px',
      boxShadow: theme.shadows[5],
    },
  })
);

interface DeleteErrorCityPageProps {
  message: string;
}

export const DeleteErrorCityPage = ({ message }: DeleteErrorCityPageProps) => {
  const classes = useStyles();

  const { onCancel } = useCancelRoute('/cities');

  return (
    <Modal
      open={true}
      onClose={onCancel}
      aria-labelledby="Ошибка удаление города"
      aria-describedby="Модальное окно с тексто ошибки при удалении города"
      className={classes.modal}
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={true}>
        <div className={classes.form}>
          <DeleteErrorCityModal message={message} onClose={onCancel} />
        </div>
      </Fade>
    </Modal>
  );
};
